import { MenuItem, TextField } from '@mui/material';
import { values } from '@weft/utils';
import React from 'react';
import type { EventsDigestedLineChartDisplayInterval } from './events-digested-line-chart/events-digested-line-chart';
import { DISPLAY_INTERVALS } from './events-digested-line-chart/events-digested-line-chart';
import { getEventsIntervalLabel } from './events-digested-section-utils/get-events-interval-label';

type EventsDigestedDisplayIntervalSelectorProps = {
  onSelectDisplayInterval: (displayInterval: EventsDigestedLineChartDisplayInterval) => void;
  defaultDisplayInterval: EventsDigestedLineChartDisplayInterval;
};

export const EventsDigestedDisplayIntervalSelector: React.FC<EventsDigestedDisplayIntervalSelectorProps> = ({ onSelectDisplayInterval, defaultDisplayInterval }) => {
  const [selectedDisplayInterval, setSelectedDisplayInterval] = React.useState<EventsDigestedLineChartDisplayInterval>(defaultDisplayInterval);

  const menuItemClickHandler = (displayInterval: EventsDigestedLineChartDisplayInterval) => {
    setSelectedDisplayInterval(displayInterval);
    onSelectDisplayInterval(displayInterval);
  };

  return (
    <TextField
      sx={{
        width: 120,
      }}
      select
      SelectProps={{
        value: selectedDisplayInterval,
        onFocus: (event) => event.target.blur(),
      }}
    >
      {values(DISPLAY_INTERVALS).map((displayInterval) => (
        <MenuItem
          key={displayInterval}
          value={displayInterval}
          onClick={() => menuItemClickHandler(displayInterval)}
        >
          {getEventsIntervalLabel(displayInterval)}
        </MenuItem>
      ),
      )}
    </TextField>
  );
}; 